"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var react_1 = require("react");
var react_final_form_1 = require("react-final-form");
var react_router_dom_1 = require("react-router-dom");
var Main_1 = __importDefault(require("components/Layout/Main"));
var LoadingSpinner_1 = __importDefault(require("components/LoadingSpinner"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var Button_1 = __importDefault(require("shared/components/Button"));
var TextField_1 = __importDefault(require("shared/components/Form/TextField"));
var validators_1 = require("utils/form/validators");
var hooks_1 = require("utils/hooks");
var WelcomeSection_1 = __importDefault(require("../WelcomeSection"));
var PREFIX = 'RequestAccess';
var classes = {
    mainWrapper: "".concat(PREFIX, "-mainWrapper"),
    wrapper: "".concat(PREFIX, "-wrapper"),
    item: "".concat(PREFIX, "-item"),
    nameBox: "".concat(PREFIX, "-nameBox"),
    submitButton: "".concat(PREFIX, "-submitButton"),
    mainText: "".concat(PREFIX, "-mainText"),
    linkText: "".concat(PREFIX, "-linkText"),
};
// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root = (0, styles_1.styled)('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.mainWrapper)] = {
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            backgroundColor: '#F6F6F0',
        },
        _b[".".concat(classes.wrapper)] = {
            flexWrap: 'nowrap',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: theme.palette.common.white,
            boxShadow: '1px 1px 5px 0 rgb(0 0 0 / 20%)',
        },
        _b[".".concat(classes.item)] = {
            margin: theme.spacing(2),
            width: '50%',
        },
        _b[".".concat(classes.nameBox)] = {
            display: 'flex',
            justifyContent: 'space-between',
        },
        _b[".".concat(classes.submitButton)] = {
            width: '100%',
            textTransform: 'uppercase',
            '& .logging': {
                marginRight: theme.spacing(1),
            },
        },
        _b[".".concat(classes.mainText)] = {
            color: theme.palette.grey[600],
        },
        _b[".".concat(classes.linkText)] = {
            fontWeight: theme.typography.fontWeightBold,
            textDecoration: 'underline',
            color: theme.palette.grey[600],
            '&:hover': {
                color: theme.palette.grey.A400,
            },
        },
        _b);
});
var RequestAccess = function () {
    var _a = __read((0, react_1.useState)(''), 2), msg = _a[0], setMsg = _a[1];
    var _b = __read((0, hooks_1.useSubmitter)('access_requests'), 2), submitAccessRequest = _b[0], isSending = _b[1];
    var onSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setMsg('');
                    return [4 /*yield*/, submitAccessRequest(__assign(__assign({}, values), { invited: false }))];
                case 1:
                    _a.sent();
                    setMsg('Your Request has been successfully submitted!');
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)(Root, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Hudled Signup", description: "Hudled Signup" }), (0, jsx_runtime_1.jsxs)(Main_1.default, __assign({ className: classes.mainWrapper }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, direction: "row", className: classes.wrapper }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 4, className: classes.item }, { children: (0, jsx_runtime_1.jsx)(WelcomeSection_1.default, { welcomeMsg: "Request access to Hudled" }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 4, className: classes.item }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: onSubmit }, { children: function (_a) {
                                        var handleSubmit = _a.handleSubmit, submitting = _a.submitting;
                                        return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ className: classes.nameBox, mt: 2 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ width: "49%" }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "firstName", color: "secondary", disabled: submitting, component: TextField_1.default, validate: (0, validators_1.required)(), label: "First Name" }) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ width: "49%" }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "lastName", color: "secondary", disabled: submitting, component: TextField_1.default, validate: (0, validators_1.required)(), label: "Last Name" }) }))] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 2 }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "workEmail", color: "secondary", disabled: submitting, component: TextField_1.default, validate: validators_1.getEmailError, label: "Work Email" }) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 2 }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "companyName", color: "secondary", disabled: submitting, component: TextField_1.default, label: "Company Name (optional)" }) })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ mt: 3 }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, __assign({ className: classes.submitButton, color: "secondary", onClick: handleSubmit, type: "submit" }, { children: !isSending
                                                                ? 'Sign up'
                                                                : ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex" }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "logging" }, { children: "Submitting" })), (0, jsx_runtime_1.jsx)(LoadingSpinner_1.default, { size: "1x" })] }))) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ textAlign: "center", mt: 1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body2", color: "primary" }, { children: msg })) }))] }))] })));
                                    } })) }))] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 3 }, { children: (0, jsx_runtime_1.jsxs)(material_1.Typography, __assign({ variant: "body2", className: classes.mainText }, { children: ["Already have an account?", ' ', (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({ className: classes.linkText, to: "/login" }, { children: "Log in" })), "."] })) }))] }))] }));
};
exports.default = RequestAccess;
